import ResizeObserver from 'resize-observer-polyfill';
const directive = {
    directives: {
        "intersectionObserver": {
            mounted: (el, binding) => {
                function hasBrowserIntersection () {
                    if (('IntersectionObserver' in window) &&  
                        ('IntersectionObserverEntry' in window) && 
                        ('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
                        return true
                    }
                    else {
                        return false
                    }
                }
                function executeCallback () {
                    if (typeof binding.value === 'function') {
                        binding.value();
                    }
                }
                if (hasBrowserIntersection) {
                    var observer = new IntersectionObserver(function (entries) {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                executeCallback();
                                observer.unobserve(entry.target);
                            }
                        });
                    });
                    observer.observe(el);
                }
                else {
                    executeCallback();
                }
            }
        },
        "fixed-block": {
            mounted: (el) => {
                let $copy;
                const init = () => {
                    $copy = $(el).clone();
                    $copy.addClass("fix-block");
                    $(el).addClass("origin-block");
                    $(el).css({
                        position: "fixed",
                        top: 50,
                        width: $(el).parent().width(),
                        "z-index": 3,
                    });
                    $(el).parent().prepend($copy);
                    new ResizeObserver( ()=> {
                        if (window.innerWidth > 767) {
                            $(el).css("width", $(el).parent().width());
                        }
                        else {
                            $(el).css("width", "100%");
                        }
                    }).observe($copy[0]);
                }
                const setCss = () => {
                    if (window.innerWidth > 767) {
                        $(el).css({
                            transition: "",
                            transform: "",
                            left: "unset",
                            width: $(el).parent().width()
                        });
                        $("header")[0].dataset.scrollHeight = 0;
                    }
                    else {
                        $(el).css({
                            transition: "transform 0.5s linear",
                            left: 0,
                            width: "100%"
                        });
                        $("header")[0].dataset.scrollHeight = $(el).outerHeight();
                    }
                }
                setTimeout(() => {
                    init();
                    setCss();
                });
                let lastScroll = 0;
                window.addEventListener('resize', function () {
                    setCss();
                });
                window.addEventListener('scroll', function() {
                    if (window.innerWidth > 767 || $('body').hasClass("stop-scroll")) {
                        return
                    }
                    const elHeight = parseInt($(el).outerHeight());
                    const currentScroll = window.pageYOffset;
                    if (currentScroll >= 60 + elHeight && currentScroll > lastScroll) {
                        $(el).css("transform", "translate(0, -"+ (elHeight + 60) + "px)");
                    }
                    else {
                        $(el).css("transform", "");
                    }
                    lastScroll = currentScroll;
                });
            }
        },
        "fixed-top-nav": {
            mounted: (el) => {
                const init = () => {
                    if (window.innerWidth > 767) {
                        $(el).css({
                            transition: "",
                            transform: ""
                        });
                    }
                    else {
                        $(el).css("transition", "transform 0.5s linear");
                    }
                }
                setTimeout(() => {
                    init();
                });
                let lastScroll = 0;
                window.addEventListener('resize', function () {
                    init();
                });
                window.addEventListener('scroll', function() {
                    if (window.innerWidth > 767 || $('body').hasClass("stop-scroll")) {
                        return
                    }
                    const elHeight = parseInt($(el).outerHeight());
                    const otherHeight = parseInt($("header")[0].dataset.scrollHeight) || 0;
                    const currentScroll = window.pageYOffset;
                    if (currentScroll >= elHeight + otherHeight && currentScroll > lastScroll) {
                        $(el).css("transform", "translate(0, -"+ elHeight + "px)");
                    }
                    else {
                        $(el).css("transform", "");
                    }
                    lastScroll = currentScroll;
                });
            }
        }
    },
    install: function(Vue) {
        for (let directiveName in this.directives) {
            Vue.directive(directiveName, this.directives[directiveName]);
        }
    }
}

export default directive;